import { useEffect, useState } from 'react'

import NexiaStream from 'services/NexiaStream'

import { useSessionContext } from 'hooks/SessionContext'

import Brand from 'helpers/brand'
import Environment from 'helpers/environment'

const useSiteMessageBanners = () => {
  const { session: { isUnknown, currentRole } } = useSessionContext()
  const [siteMessageBanners, setSiteMessageBanners] = useState(null)
  const brand = Brand.current()
  const url = `${Environment.backendApiURL()}/stream/site_messages/${brand}`

  useEffect(() => {
    if (isUnknown) {
      return
    }

    const eventListenerCallback = (event) => {
      if (event.data) {
        const report = JSON.parse(event.data)

        setSiteMessageBanners(report)
      }
    }

    NexiaStream.instance().addEventListener(`${brand}_${currentRole}_site_message_banners`, eventListenerCallback)

    NexiaStream.instance().whenConnected(() =>
      NexiaStream.instance().subscribeTo(url)
    )

    return () => {
      NexiaStream.instance().removeEventListener(`${brand}_${currentRole}_site_message_banners`, eventListenerCallback)
    }
  }, [isUnknown, url, brand, currentRole])

  return { siteMessageBanners }
}

export default useSiteMessageBanners
